<template>
  <div>
    <b-container>
      <b-row>
        <b-col cols="12" lg="3" v-for="cardNew in cardNews" :key="cardNew.id">
          <b-card
            :img-src="cardNew.newsImage"
            :sub-title="cardNew.intervieweeInfo"
            align="center"
          >
            <b-card-text>{{ cardNew.students }}</b-card-text>
            <b-button :href="cardNew.newsAddress" variant="primary"
              >더 알아보기</b-button
            >
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    cardNews: {
      type: Array
    }
  }
};
</script>

<style>
.container {
  padding-top: 40px;
  padding-bottom: 40px;
}
</style>
